import React from "react";
import AddNewTask from "../components/AddNewTask/AddNewTask";

export default function AddNew() {
  return (
    <div className="container relative">
      <AddNewTask />
    </div>
  );
}
